var map = {
	"./": 313,
	"./LiveStream.module.scss": 336,
	"./LiveStreamDeferred": 1123,
	"./LiveStreamDeferred.tsx": 1123,
	"./actions": 144,
	"./actions.ts": 144,
	"./components/MatchesDropdown": 289,
	"./components/MatchesDropdown/": 289,
	"./components/MatchesDropdown/DropdownComponents": 354,
	"./components/MatchesDropdown/DropdownComponents.tsx": 354,
	"./components/MatchesDropdown/MatchesDropdown.dictionary": 170,
	"./components/MatchesDropdown/MatchesDropdown.dictionary.json": 170,
	"./components/MatchesDropdown/MatchesDropdown.module.scss": 251,
	"./components/MatchesDropdown/index": 289,
	"./components/MatchesDropdown/index.tsx": 289,
	"./components/MatchesDropdown/sport-utils": 355,
	"./components/MatchesDropdown/sport-utils.ts": 355,
	"./components/Players": 963,
	"./components/Players/": 963,
	"./components/Players/HLSHandler": 1026,
	"./components/Players/HLSHandler.tsx": 1026,
	"./components/Players/Twitch/TwitchHandler": 1027,
	"./components/Players/Twitch/TwitchHandler.module.scss": 1085,
	"./components/Players/Twitch/TwitchHandler.tsx": 1027,
	"./components/Players/Twitch/global.d": 1124,
	"./components/Players/Twitch/global.d.ts": 1124,
	"./components/Players/YouTubeHandler": 1028,
	"./components/Players/YouTubeHandler.tsx": 1028,
	"./components/Players/index": 963,
	"./components/Players/index.ts": 963,
	"./components/ToolbarButtons": 291,
	"./components/ToolbarButtons/": 291,
	"./components/ToolbarButtons/ToolbarButtons.dictionary": 356,
	"./components/ToolbarButtons/ToolbarButtons.dictionary.json": 356,
	"./components/ToolbarButtons/index": 291,
	"./components/ToolbarButtons/index.tsx": 291,
	"./components/ToolbarControls": 290,
	"./components/ToolbarControls/": 290,
	"./components/ToolbarControls/ToolbarControls.dictionary": 357,
	"./components/ToolbarControls/ToolbarControls.dictionary.json": 357,
	"./components/ToolbarControls/index": 290,
	"./components/ToolbarControls/index.tsx": 290,
	"./constants": 209,
	"./constants.ts": 209,
	"./index": 313,
	"./index.tsx": 313,
	"./local-storage-helpers": 250,
	"./local-storage-helpers.ts": 250,
	"./records": 345,
	"./records.ts": 345,
	"./reducer": 293,
	"./reducer/": 293,
	"./reducer/index": 293,
	"./reducer/index.ts": 293,
	"./selectors": 97,
	"./selectors/": 97,
	"./selectors/index": 97,
	"./selectors/index.ts": 97,
	"./selectors/selectors": 284,
	"./selectors/selectors.spec": 1125,
	"./selectors/selectors.spec.js": 1125,
	"./selectors/selectors.ts": 284,
	"./types": 1006,
	"./types/": 1006,
	"./types/backend/liveStream": 1126,
	"./types/backend/liveStream.ts": 1126,
	"./types/index": 1006,
	"./types/index.ts": 1006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1246;
module.exports = webpackContext;